import React from 'react';
export function ForWho() {
  const targets = [{
    icon: '🦷',
    title: 'Odontólogos con consultorio propio',
    desc: 'Tenés pacientes, tenés asistente, pero te falta el sistema que haga que todo funcione sin que vos estés en cada paso.'
  }, {
    icon: '📋',
    title: 'Sin protocolos escritos',
    desc: 'Todo está en tu cabeza. Los consentimientos son informales, la historia clínica incompleta y la recepción depende del día.'
  }, {
    icon: '⚖️',
    title: 'Con riesgo legal sin cubrir',
    desc: 'Sabés que deberías tener respaldo legal en cada procedimiento. Nunca encontraste algo listo para usar en Argentina.'
  }, {
    icon: '🚀',
    title: 'Que quiere escalar o incorporar socios',
    desc: 'Querés abrir otra sede o sumar otro profesional y te dás cuenta de que sin protocolos escritos es imposible crecer.',
    isNew: true
  }];
  return <section className="bg-white px-5 py-10 md:py-[70px] text-center" data-id="element-84">
      <div className="mx-auto max-w-[960px]" data-id="element-85">
        <p className="mb-3 font-montserrat text-[11px] font-extrabold uppercase tracking-[3px] text-brandRed" data-id="element-86">
          ¿Para quién es?
        </p>
        <h2 className="mb-2 font-bebas text-[clamp(30px,5vw,52px)] text-navy" data-id="element-87">
          Diseñado para vos si querés llevar tu consultorio al siguiente nivel
        </h2>
        <p className="mb-6 md:mb-[44px] text-[16px] text-brandGray" data-id="element-88">
          ¿No estás seguro si es para vos? Tenés 7 días de garantía →
        </p>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-89">
          {targets.map((target, i) => <div key={i} className="rounded-xl border-[1.5px] border-brandGray-light p-[28px_22px] text-left transition-all hover:border-brandRed hover:shadow-[0_4px_20px_rgba(230,57,70,0.1)]" data-id="element-90">
              {target.isNew && <span className="mb-2 inline-block rounded-[3px] bg-gold px-2 py-[3px] font-montserrat text-[9px] font-extrabold uppercase tracking-[1.5px] text-navy" data-id="element-91">
                  Nuevo
                </span>}
              <div className="mb-3 text-[28px]" data-id="element-92">{target.icon}</div>
              <p className="mb-2 font-montserrat text-[15px] font-bold text-navy" data-id="element-93">
                {target.title}
              </p>
              <p className="text-[13px] leading-relaxed text-brandGray" data-id="element-94">
                {target.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}